import { render, staticRenderFns } from "./AdminsList.vue?vue&type=template&id=2899474d"
import script from "./AdminsList.vue?vue&type=script&lang=js"
export * from "./AdminsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2899474d')) {
      api.createRecord('2899474d', component.options)
    } else {
      api.reload('2899474d', component.options)
    }
    module.hot.accept("./AdminsList.vue?vue&type=template&id=2899474d", function () {
      api.rerender('2899474d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Admins/AdminsList.vue"
export default component.exports